import React from 'react'
import PropType from 'prop-types'
import BaseSelect from './BaseSelect'
import ChipSelect from './ChipSelect'

function Select({
  chipClassName,
  chipsClassName,
  className,
  defaultLabel,
  disabled,
  inputLabel,
  items,
  onChange,
  onClose,
  required,
  textColor,
  value,
  variant,
}) {
  switch (variant) {
    case 'chip':
      return (
        <ChipSelect
          chipClassName={chipClassName}
          chipsClassName={chipsClassName}
          items={items}
          onChange={onChange}
          onClose={onClose}
          value={value}
        />
      )
    default:
      return (
        <BaseSelect
          className={className}
          disabled={disabled}
          defaultLabel={defaultLabel}
          inputLabel={inputLabel}
          items={items}
          onChange={onChange}
          required={required}
          textColor={textColor}
          value={value}
        />
      )
  }
}

Select.defaultProps = {
  className: '',
  chipClassName: '',
  chipsClassName: '',
  defaultLabel: '',
  disabled: false,
  inputLabel: '',
  onChange: null,
  onClose: null,
  required: false,
  textColor: '#000',
  value: [],
  variant: 'default',
}

Select.propTypes = {
  className: PropType.string,
  chipClassName: PropType.string,
  chipsClassName: PropType.string,
  defaultLabel: PropType.string,
  disabled: PropType.bool,
  inputLabel: PropType.string,
  items: PropType.arrayOf(
    PropType.object,
  ).isRequired,
  onChange: PropType.func,
  onClose: PropType.func,
  required: PropType.bool,
  textColor: PropType.string,
  value: PropType.oneOfType(
    [
      PropType.string,
      PropType.number,
      PropType.array,
      PropType.object,
      PropType.bool,
    ],
  ),
  variant: PropType.oneOf(['chip', 'default']),
}

export default Select
